import React from 'react'
import {
    FiPackage,
    FiHome,
    FiUsers,
    FiUserCheck,
    FiLink, FiBriefcase,
    FiSettings, FiBarChart2, FiCreditCard,
} from 'react-icons/fi'
import { AiOutlineBarChart, AiOutlineNotification } from 'react-icons/ai'
import { IoApps, IoGlobeOutline, IoRocketOutline, IoRocketSharp } from 'react-icons/io5'
import Immutable from 'seamless-immutable'

import { IconAdCampaings, IconApps, IconDashboard, IconDomains, IconExternalService, IconPushNotifications, IconStatistics, IconTeamInvitations, IconTeamMembers, IconTeamRoles, IconTeams, IconTeams2 } from '../../components/icons'
import {RiTeamLine} from "react-icons/ri";

const INITIAL_STATE_DASHBOARD = {
	url: '/dashboard',
	icon: <IconDashboard size={20} />,
	title: 'nav_menu.section_menu.dashboard',
	items: []
}
const INITIAL_STATE_DRAFT = {
	url: '/draft',
	icon: <IconDashboard size={20} />,
	title: 'nav_menu.section_menu.draft',
	items: []
}
const INITIAL_STATE_TEAMS = {
	url: '/teams',
	icon: <IconTeams2 size={20} />,
	title: 'nav_menu.section_menu.teams',
	items: [
		{
			url: '/teams/team',
			icon: <IconTeams size={20} />,
			title: 'nav_menu.section_menu.teams',
			permission: 'team list',
			items: [],
		},
		{
			url: '/teams/role',
			icon: <IconTeamRoles size={20} />,
			title: 'nav_menu.section_menu.teams_roles',
			permission: 'role list',
			items: [],
		},
		// {
		// 	url: '/teams/member/1',
		// 	icon: <IconTeamMembers size={20} />,
		// 	title: 'nav_menu.section_menu.teams_users',
		// 	permission: 'user list',
		// 	items: [],
		// },
		{
			url: '/teams/invitation',
			icon: <IconTeamInvitations size={20} />,
			title: 'nav_menu.section_menu.teams_invitations',
			permission: 'user_invite list',
			items: [],
		},
		// // for debug
		// {
		// 	url: '/teams/invitation/activation/xxx',
		// 	icon: <IconTeamMembers size={20} />,
		// 	title: 'nav_menu.section_menu.teams_invitations',
		// 	permission: 'user_invite list',
		// 	items: [],
		// },
	],
}
const INITIAL_STATE_EXT_SERVICES = {
	url: '/extservices',
	icon: <IconExternalService size={20} />,
	title: 'nav_menu.section_menu.external_services',
	permission: 'external_service list',
	items: []
}
const INITIAL_STATE_DOMAIN = {
	url: '/domains',
	icon: <IconDomains size={20} />,
	title: 'nav_menu.section_menu.domains',
	permission: 'domain list',
	items: []
}
const INITIAL_STATE_ADCAMPAINS = {
	url: '/adcampaigns',
	icon: <IconAdCampaings size={20} />,
	title: 'nav_menu.section_menu.adcampaigns',
	permission: 'adcampaign list',
	items: []
}
const INITIAL_STATE_APPS = {
	url: '/apps',
	icon: <IconApps size={20} />,
	title: 'nav_menu.section_menu.apps',
	permission: 'app list',
	items: []
}
const INITIAL_STATE_STATISTICS = {
	url: '/statistics',
	// icon: <AiOutlineBarChart size={20}/>,
	icon: <IconStatistics size={20} />,
	title: 'nav_menu.section_menu.statistics.section_title',
	items: [
		// {
		//     url: '/statistics/general',
		//     icon: false,
		//     title: 'nav_menu.section_menu.statistics.general',
		//     permission: 'statistics general',
		//     items: []
		// },
		{
			url: '/statistics/teams',
			icon: false,
			title: 'nav_menu.section_menu.statistics.teams',
			permission: 'statistics teams',
			items: []
		},
		{
			url: '/statistics/top100',
			icon: false,
			title: 'nav_menu.section_menu.statistics.top100',
			permission: 'statistics top100',
			items: []
		},
		{
			url: '/statistics/app',
			icon: false,
			title: 'nav_menu.section_menu.statistics.app',
			permission: 'statistics app',
			items: []
		},
	]
}
const INITIAL_STATE_NEWSLETTERS = {
	url: '/push/newsletters',
	icon: <IconPushNotifications size={20} />, // <AiOutlineNotification size={20} />
	title: 'nav_menu.section_menu.notifications',
	permission: 'pushnewsletter list',
	items: []
}
export const INITIAL_STATE = Immutable([
	{
		title: 'nav_menu.section_menu.title',
		items: [
			INITIAL_STATE_DASHBOARD,
			window.location.origin === 'http://panel.pwa.local:3000' ? INITIAL_STATE_DRAFT : null,
			INITIAL_STATE_TEAMS,
			INITIAL_STATE_EXT_SERVICES,
			INITIAL_STATE_DOMAIN,
			INITIAL_STATE_ADCAMPAINS,
			INITIAL_STATE_APPS,
			INITIAL_STATE_STATISTICS,
			INITIAL_STATE_NEWSLETTERS,
		].filter(_ => !!_)
	},
	// {
	// 	title: 'nav_menu.section_push.title',
	// 	items: [
	// 		{
	// 			url: '/push/newsletters',
	// 			icon: <IconPushNotifications size={20} />,
	// 			// icon: <AiOutlineNotification size={20} />,
	// 			title: 'nav_menu.section_push.notifications',
	// 			permission: 'pushnewsletter list',
	// 			items: []
	// 		},
	// 	]
	// },
	{
		title: 'nav_menu.section_utils.title',
		items: [
			{
					url: '/utils/trackingpixels',
					icon: <FiHome size={20} />,
					title: 'nav_menu.section_utils.trackingpixels',
					permission: 'tracking_pixel list',
					items: []
			},
			{
				url: '/utils/warmingup',
				icon: <FiHome size={20} />,
				title: 'nav_menu.section_utils.warmingup',
				permission: 'utils_warmingup list',
				items: []
			},
		]
	},

    {
        title: 'nav_menu.section_billing.title',
        items: [
            {
                url: '/billing/statistics',
                icon: <FiBarChart2 size={20} />,
                title: 'nav_menu.section_billing.statistics',
                permission: 'finance list',
                items: []
            },
            {
                url: '/billing/paymenthistory',
                icon: <FiCreditCard size={20} />,
                title: 'nav_menu.section_billing.paymenthistory',
                permission: 'finance list',
                items: []
            },
            {
                url: '/billing/referrals',
                icon: <RiTeamLine size={20} />,
                title: 'nav_menu.section_billing.referrals',
                permission: 'finance list',
                items: [],
                canShow: (state) => state?.settings?.referral_program_active,
            },
        ]
    },
	// hidded unused menu-option from OLD system (info from PM)
	/*{
		title: 'nav_menu.section_farm.title',
		items: [
			{
				url: '/farm/accounts',
				icon: <FiHome size={20} />,
				title: 'nav_menu.section_farm.accounts',
				permission: 'farm_account list',
				items: []
			},
		]
	},*/
	// hidded unused 2 menu-options from OLD system (info from PM)
	/*{
		title: 'nav_menu.section_list.title',
		items: [
			{
				url: '/list/gpusers',
				icon: <FiHome size={20} />,
				title: 'nav_menu.section_list.gpusers',
				permission: 'list_gp_user list',
				items: []
			},
			{
				url: '/list/gpcomments',
				icon: <FiHome size={20} />,
				title: 'nav_menu.section_list.gpcomments',
				permission: 'list_gp_comment list',
				items: []
			},
		]
	},*/
	{
		title: 'nav_menu.section_user.title',
		items: [
			{
				url: '/user',
				icon: <FiUsers size={20} />,
				title: 'nav_menu.section_user.profile',
				permission: '',
				items: []
			},
		]
	},
	{
		title: 'nav_menu.section_admin.title',
		role: 'admin',
		items: [
			{
				url: '/admin/finance',
				icon: <FiUsers size={20} />,
				title: 'nav_menu.section_admin.finance',
				permission: 'project_finance view',
				items: []
			},
			{
				url: '/admin/users',
				icon: <FiUsers size={20} />,
				title: 'nav_menu.section_admin.users',
				permission: 'user list',
				items: []
			},
			{
				url: '/admin/roles',
				icon: <FiUserCheck size={20} />,
				title: 'nav_menu.section_admin.roles',
				permission: 'role list',
				items: []
			},
            {
                url: '/admin/tariffs',
                icon: <AiOutlineBarChart size={20} />,
                title: 'nav_menu.section_admin.tariffs',
                // permission: 'statistics list',
                items: [
                    {
                        url: '/admin/tariffs/countrygroups',
                        icon: <FiBriefcase size={20} />,
                        title: 'nav_menu.section_admin.country_groups',
                        permission: 'country_group list',
                        items: []
                    },
                    {
                        url: '/admin/tariffs/countries',
                        icon: <FiBriefcase size={20} />,
                        title: 'nav_menu.section_admin.countries',
                        permission: 'country list',
                        items: []
                    },
                    {
                        url: '/admin/tariffs/subscriptions',
                        icon: <FiBriefcase size={20} />,
                        title: 'nav_menu.section_admin.subscriptions',
                        permission: 'subscription list',
                        items: []
                    },
                ]
            },
			{
				url: '/admin/domain_prices',
				icon: <IconDomains size={20} />,
				title: 'nav_menu.section_admin.domain_prices',
				permission: 'domain_price list',
				items: []
			},
			{
				url: '/admin/settings',
				icon: <FiSettings size={20} />,
				title: 'nav_menu.section_admin.settings',
				permission: 'project_settings edit',
				items: []
			},
		]
	},
]);

export const NavigationMenuAction = {
    updateMenuByUser: (userPermissions) => (dispatch, getState) => {
        return dispatch({
            type: 'UPDATE_MENU_BY_USER',
            userPermissions: userPermissions,
            rootState: getState()
        });
    },

}


function prepareMenu(menu, currentValue, userPermissions, rootState){
	let menuItems = currentValue.items.reduce((subMenu, subCurrentValue)=>{
        if(typeof subCurrentValue.canShow === 'function' && !subCurrentValue.canShow(rootState)) return subMenu;
		if(
            !subCurrentValue.permission
            || subCurrentValue.permission.length === 0
            || userPermissions.includes(subCurrentValue.permission)
        ){
			if(subCurrentValue.items && subCurrentValue.items.length > 0){
				subMenu = prepareMenu(subMenu, subCurrentValue, userPermissions, rootState);
			} else subMenu.push(subCurrentValue);
		}
		return subMenu;
	}, []);
	if(menuItems.length > 0) menu.push(currentValue.merge({items: menuItems}));

	return menu;
}
function updateMenuByUser(state, action) {
	const { userPermissions, rootState } = action;
	state = state.reduce((menu, currentValue)=>{
		return prepareMenu(menu, currentValue, userPermissions, rootState);
	}, []);

	return Immutable(state);
}


export default function navigationMenu(state = INITIAL_STATE, action) {
	switch (action.type) {
		case 'UPDATE_MENU_BY_USER':
			return updateMenuByUser(INITIAL_STATE, action);
		default:
			return state
	}
}
